export const ListQueryKey = 'assets';
export const DetailQueryKey = 'asset';

export const Urls = {
  selectUrl: '/assets/list',
  updateUrl: '/assets/update',
  deleteUrl: '/assets/delete',
  createUrl: '/assets/create',
  detailUrl: '/assets/detail',
};
